import script from "./ApplicationBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationBar.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationBar.vue?vue&type=style&index=0&id=3c57cb17&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c57cb17"]])

export default __exports__